import userSearch from './user-search';

export default {
  ...userSearch,
};
